// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AccessProvider } from './contexts/AccessContext';
import { ProtectedRoute, SuperAdminRoute, ToolRoute, DeanRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Home from './pages/Home';
import ToolPlaceholder from './pages/ToolPlaceholder';
import SurveyList from './pages/surveys/SurveyList';
import SurveyBuilder from './pages/surveys/SurveyBuilder';
import SurveyResults from './pages/surveys/SurveyResults';
import SurveyPublic from './pages/surveys/SurveyPublic';
import './styles/globals.css';
import Flashcards from './pages/Flashcards';
import AudioTranscriber from './components/AudioTranscriber';
import Gateway from './pages/Gateway';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import GatewayPeerBenchmark from './pages/Gateway';
import AIChartGenerator from './pages/AiChartGenerator';
import SuperAdminPanel from './pages/SuperAdminPanel';
import CanvasAnalytics from './pages/CanvasAnalytics';
import SurveyMonkeyTool from './pages/SurveyMonkeyTool';
import DataAnalyst from './pages/DataAnalyst';
import VeracrossUpload from './pages/VeracrossUpload';
import StorylanePage from './pages/StorylanePage';
import MsBellSchedule from './pages/msBellSchedule';
import APScoreAlignmentExplorer from './pages/APExplorer';
import SuperAdminAccept from './pages/SuperAdminAccept';
import LiveScript from './pages/LiveScript';
import StudentAction from "./pages/StudentAction";
import APAlignment from "./pages/APAlignment";
import NAISExplorer from "./pages/NAISExplorer";
import AdmissionsExplorer from "./pages/AdmissionsExplorer";
import StudentCheckout from "./pages/StudentCheckout";
import MsCheckout from "./pages/MsCheckout";
import StudentRoute from './components/StudentRoute';
import MyCheckout from './pages/MyCheckout';
import Telegraph from './pages/Telegraph';
import CheckoutReports from "./pages/CheckoutReports";
import DepartmentReview from "./pages/DepartmentReview";
import StopGoContinue from './pages/StopGoContinue';
import StopGoContinueAnalyst from './pages/StopGoContinueAnalyst';
import Openingofschool from './pages/Openingofschool';
import FacultyOrientation from "./pages/FacultyOrientation";
import Checkin from './pages/Checkin';
import PhoneCheckin from './pages/PhoneCheckIn';
import LexileLeveler from './components/LexileLeveler';
import HandbookBot from './components/HandbookBot';
import CubbyCheckIn from "./pages/CubbyCheckIn";
import AttendanceEmailAnalytics from "./pages/AttendanceEmailAnalytics";
import MopsDashboard from './pages/MopsDashboard';
import AdvisoryDashboard from './pages/AdvisoryDashboard';
import AbsenceDashboard from './pages/AbsenceDashboard';
import GradebookAudit from './pages/GradebookAudit';
import Jeopardy from './pages/Jeopardy';
import Ch3Jeopardy from './pages/Ch3Jeopardy';
import PhoneEmailDashboard from "./pages/PhoneEmailDashboard";
import BellSchedule from "./pages/BellSchedule";
import BellScheduleEditor from "./pages/BellScheduleEditor";
import Handbookjeopardy from "./pages/Handbookjeopardy";
import CubbyManager from './pages/CubbyManager';
import ProjectManager from './pages/ProjectManager';
import TripSpaces from "./pages/TripSpaces";
import TripJoin from "./pages/TripJoin";
import EventManager from "./pages/EventManager";
import StudentEvents from "./pages/StudentEvents";
import Ch4Jeopardy from "./pages/jeopardych4";
import Newtonscannon from "./pages/Newtonscannon";
import Gravityrankingchallenge from "./pages/Gravityrankingchallenge";
import OrbitLab from "./pages/Orbitlab";
import LaunchPage from "./pages/LaunchPage";
import Virtualteachingpractice from "./pages/Virtualteachingpractice";
import StudentCoco from './pages/StudentCoco';
import Thermalexpansionlab from "./pages/Thermalexpansionlab.jsx";
import CocoManager from './pages/CocoManager';
import CocoDashboard from './pages/cocos/CocoDashboard';


export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AccessProvider>
          <Routes>

            {/* Public routes — no auth required */}
            <Route path="/login" element={<Login />} />
            <Route path="/s/:id" element={<SurveyPublic />} />
            <Route path="/flashcards" element={<Flashcards />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/tools/demos" element={<StorylanePage />} />
            <Route path="/tools/bell-schedule" element={<BellSchedule />} />
            <Route path="/tools/ms-bell-schedule" element={<MsBellSchedule />} />
            <Route path="/telegraph" element={<Telegraph />} />
            <Route path="/orientation" element={<Openingofschool />} />
            <Route path="/facultyorientation" element={<FacultyOrientation />} />
            <Route path="/opening-of-school" element={<Navigate to="/orientation" replace />} />
            <Route path="/phones" element={<PhoneCheckin />} />
            <Route path="/gateway" element={<Gateway />} />
            <Route path="/handbook" element={<HandbookBot />} />
            <Route path="/jeopardy" element={<Jeopardy />} />
            <Route path="/handbook-jeopardy" element={<Handbookjeopardy />} />
            <Route path="/ch3-jeopardy" element={<Ch3Jeopardy />} />
            <Route path="/ch4jeopardy" element={<Ch4Jeopardy />} />
            <Route path="/cannon" element={<Newtonscannon />} />
            <Route path="/gravity" element={<Gravityrankingchallenge />} />
            <Route path="/orbitlab" element={<OrbitLab />} />
            <Route path="/launch" element={<LaunchPage />} />
            <Route path="/thermal" element={<Thermalexpansionlab />} />
            <Route path="/virtual" element={<Virtualteachingpractice />} />
            <Route path="/benchmarking"    element={<GatewayPeerBenchmark />} />  {/*make these private eventually*/}
            <Route path="/chart-generator" element={<AIChartGenerator />} />      {/*make these private eventually*/}

            {/* Auth-only, NOT tool-gated: reachable by any signed-in KA user
                (students + teachers). Must live OUTSIDE the faculty Layout so
                ProtectedRoute doesn't bounce students to /my-checkout. The
                student sign-up page and the QR join/boarding landing both go
                here. Faculty get an in-Layout copy at /tools/trip-signup. */}
            <Route path="/events" element={<StudentEvents />} />
            <Route path="/trip-join" element={<TripJoin />} />

            {/* Student-only — outside the faculty Layout so students never
                see the sidebar/topbar. StudentRoute redirects faculty/super
                admins back to the home dashboard, and unauthenticated users
                to /login. */}
            <Route path="/my-checkout" element={<StudentRoute><MyCheckout /></StudentRoute>} />
            <Route path="/cocurriculars" element={<StudentRoute><StudentCoco /></StudentRoute>} />

            {/* Protected — wrapped in Layout (sidebar + topbar). ProtectedRoute
                bounces authenticated students to /my-checkout, so no faculty
                page below is reachable as a student. */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Home />} />

              {/* Tool list — available to all faculty when added by SuperAdmin */}
              <Route path="/tools/relief-roster" element={<ToolPlaceholder />} />
              <Route path="/tools/surveys" element={<SurveyList />} />
              <Route path="/tools/surveys/new" element={<SurveyBuilder />} />
              <Route path="/tools/surveys/edit/:id" element={<SurveyBuilder />} />
              <Route path="/tools/surveys/results/:id" element={<SurveyResults />} />
              <Route path="/student-action" element={<StudentAction />} />
              <Route path="/tools/student-checkout" element={<StudentCheckout />} />
              <Route path="/tools/checkin" element={<ToolRoute toolId="checkin"><Checkin /></ToolRoute>} />
              <Route path="/tools/stop-go-continue-analyst" element={<ToolRoute toolId="stopGoContinueAnalyst"><StopGoContinueAnalyst /></ToolRoute>} />
              <Route path="/stop-go-continue" element={<ToolRoute toolId="stopGoContinue"><StopGoContinue /></ToolRoute>} />
              <Route path="/tools/checkout-reports" element={<ToolRoute toolId="checkout_reports"><CheckoutReports /></ToolRoute>} />
              <Route path="/tools/ms-checkout" element={<ToolRoute toolId="ms_checkout"><MsCheckout /></ToolRoute>} />
              <Route path="/tools/admissions-explorer" element={<ToolRoute toolId="admissions_explorer"><AdmissionsExplorer /></ToolRoute>} />
              <Route path="/tools/lexile" element={<ToolRoute toolId="lexile_leveler"><LexileLeveler /></ToolRoute>} />
              <Route path="/tools/cubby-checkin" element={<ProtectedRoute><CubbyCheckIn /></ProtectedRoute>} />
              <Route path="/tools/attendance-email-analytics" element={<ProtectedRoute><AttendanceEmailAnalytics /></ProtectedRoute>} />
              <Route path="/tools/mops" element={<ToolRoute toolId="mops"><MopsDashboard /></ToolRoute>} />
              <Route path="/tools/advisory" element={<ToolRoute toolId="advisory"><AdvisoryDashboard /></ToolRoute>} />
              <Route path="/tools/events" element={<EventManager />} />
              <Route path="/tools/cocurriculars" element={<CocoDashboard />} />
              {/* Faculty-facing copy of the student sign-up page, inside the
                  Layout so the sidebar stays. Students use the bare /events
                  route above; this is the one the nav tile points at. */}
              <Route path="/tools/trip-signup" element={<StudentEvents />} />
              <Route path="/tools/trip-spaces" element={<TripSpaces />} />

              {/*<Route path="/tools/gradebook-audit" element={<DeanRoute><GradebookAudit /></DeanRoute>} />*/}
              <Route path="/bell-editor" element={<ToolRoute toolId="bellScheduleAdmin"><BellScheduleEditor division="upperSchool" toolId="bellScheduleAdmin" /></ToolRoute>} />
              <Route path="/ms-bell-editor" element={<ToolRoute toolId="bellScheduleAdminMs"><BellScheduleEditor division="middleSchool" toolId="bellScheduleAdminMs" /></ToolRoute>} />
              <Route path="/tools/phone-emails" element={<ToolRoute toolId="phone_emails"><PhoneEmailDashboard /></ToolRoute>} />

              {/* Non-default tools — require explicit SuperAdmin grant */}
              <Route path="/tools/transcriber" element={<ToolRoute toolId="transcriber"><AudioTranscriber /></ToolRoute>} />
              <Route path="/tools/ap-explorer" element={<ToolRoute toolId="ap_explorer"><APScoreAlignmentExplorer /></ToolRoute>} />
              <Route path="/tools/ap-alignment" element={<ToolRoute toolId="ap_alignment"><APAlignment /></ToolRoute>} />
              <Route path="/tools/nais-explorer" element={<ToolRoute toolId="nais_explorer"><NAISExplorer /></ToolRoute>} />
              <Route path="/tools/canvas-analytics" element={<ToolRoute toolId="canvas_analytics"><CanvasAnalytics /></ToolRoute>} />
              <Route path="/tools/survey-monkey" element={<ToolRoute toolId="survey_monkey"><SurveyMonkeyTool /></ToolRoute>} />
              <Route path="/tools/data-analyst" element={<ToolRoute toolId="data_analyst"><DataAnalyst /></ToolRoute>} />
              <Route path="/tools/veracross-upload" element={<ToolRoute toolId="veracross_upload"><VeracrossUpload /></ToolRoute>} />
              <Route path="/tools/department-review" element={<ToolRoute toolId="department_review"><DepartmentReview /></ToolRoute>} />
              <Route path="/tools/live-script" element={<ProtectedRoute><LiveScript /></ProtectedRoute>} />
              <Route path="/tools/cubby-manager" element={<ToolRoute toolId="cubby_manager"><DeanRoute><CubbyManager /></DeanRoute></ToolRoute>} />
              <Route path="/tools/project-manager" element={<ToolRoute toolId="project_manager"><ProjectManager /></ToolRoute>} />
              <Route path="/superadmin-accept" element={<ProtectedRoute><SuperAdminAccept /></ProtectedRoute>} />
              <Route path="/tools/phone-checkin" element={<ProtectedRoute><PhoneCheckin /></ProtectedRoute>} />
              <Route path="/tools/absence-dashboard" element={<ToolRoute toolId="unexcused-absences"><AbsenceDashboard /></ToolRoute>} />
              <Route path="/cocos" element={<CocoDashboard />} />
              <Route path="/handbook" element={<ProtectedRoute><HandbookBot /></ProtectedRoute>} />

              {/* SuperAdmin only */}
              <Route path="/superadmin" element={<SuperAdminRoute><SuperAdminPanel /></SuperAdminRoute>} />
              <Route path="/superadmin/*" element={<SuperAdminRoute><SuperAdminPanel /></SuperAdminRoute>} />

            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AccessProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}